import type { TranslationCatalog } from "../TranslationManager";

export const es: TranslationCatalog = {
  "labels.cardNumber": "Número de tarjeta",
  "labels.expirationDate": "Fecha de vencimiento",
  "labels.cvc": "Código de seguridad",
  "placeholders.cardNumber": "1234 1234 1234 1234",
  "placeholders.expirationDate": "MM / AA",
  "placeholders.cvc": "CVV",
  "errors.invalidCardNumber": "El número de su tarjeta es inválido.",
  "errors.invalidExpiryDate": "La fecha de vencimiento de su tarjeta es inválida.",
  "errors.invalidCvc": "El código de seguridad de su tarjeta es inválido.",
  "errors.incompleteCardNumber": "El número de su tarjeta está incompleto.",
  "errors.incompleteExpiryDate": "La fecha de vencimiento de su tarjeta está incompleta.",
  "errors.incompleteCvc": "El código de seguridad de su tarjeta está incompleto.",
  "errors.expiredCard": "Su tarjeta ha expirado.",
  "aria.cardNumber": "Número de tarjeta",
  "aria.expirationDate": "Fecha de vencimiento",
  "aria.cvc": "Código de seguridad",
  "aria.cardInput": "Información de tarjeta",
};
